import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.to-string.js";
export var sum = function sum(numbers) {
  return numbers.reduce(function (a, b) {
    return a + b;
  }, 0);
};